import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useInspectionStyle } from './Inspection.styles';
import { useGetProject } from '../../../../queries/queryProjects';
import { connect } from 'react-redux';
import { getCurrentUser } from '../../../../utils/auth';
import { ButtonInspection } from './ButtonInspection';
import { SummaryInspectionContract } from './SummaryInspectionContract';
import { Box, Divider, Grid, LinearProgress, makeStyles, Tooltip, Typography } from '@material-ui/core';
import { CollapsibleContainer } from './CollapsibleContainer';
import { FormattedMessage } from 'react-intl';
import { MoreDetailInspectionContract } from './MoreDetailInspectionContract';
import Button from '../../../../components/button';
import { Link } from 'react-router-dom';
import { isTextTruncated } from '../../../Projects/components/project/utils';

const useStyles = makeStyles({
  shortcutsContainer: { marginTop: '10px' },
  goToSiteProfile: {
    '& > *': {
      width: '100%',
      textAlign: 'center'
    }
  },
  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
});

const TooltipWrapper = ({ children, show, projectAlias }) => {
  if (show) {
    return (
      <Tooltip
        title={
          <FormattedMessage
            id="programs.inspection.goToSiteProfile"
            values={{ projectAlias: projectAlias || <FormattedMessage id="common.project" /> }}
          />
        }
        arrow
      >
        <Box>{children}</Box>
      </Tooltip>
    );
  }
  return children;
};

const InspectionComponent = ({ projectId, currentUser }) => {
  const [showGoToProfileTooltip, setShowGoToProfileTooltip] = useState(false);
  const { data: project, isLoading, isFetching } = useGetProject({
    clientId: currentUser.client_id,
    projectId
  });
  const { inspectionClasses, preloadingContainerClasses } = useInspectionStyle();
  const classes = useStyles();
  const { client_project_alias: clientProjectAlias = '' } = currentUser;

  if (isLoading || isFetching) {
    return (
      <Grid container classes={preloadingContainerClasses}>
        <LinearProgress />
      </Grid>
    );
  }

  return (
    <Grid container classes={inspectionClasses} direction="column">
      {project.main_contract && (
        <>
          <Grid container justifyContent="space-between" className={classes.shortcutsContainer} spacing={2} wrap="nowrap">
            <Grid item xs={12} sm={6}>
              <TooltipWrapper show={showGoToProfileTooltip} projectAlias={clientProjectAlias}>
                <Button
                  component={Link}
                  to={`/projects/${project.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="outlined"
                  color="primary"
                  fullWidth
                  className={classes.goToSiteProfile}
                >
                  <Typography
                    noWrap
                    className={classes.ellipsis}
                    ref={el => {
                      if (el) {
                        const truncated = isTextTruncated(el);
                        if (showGoToProfileTooltip !== truncated) {
                          setShowGoToProfileTooltip(truncated);
                        }
                      }
                    }}
                  >
                    <FormattedMessage
                      id="programs.inspection.goToSiteProfile"
                      values={{ projectAlias: clientProjectAlias || <FormattedMessage id="common.project" /> }}
                    />
                  </Typography>
                </Button>
              </TooltipWrapper>
            </Grid>
            <Grid item xs={12} sm={6}>
              <ButtonInspection project={project} />
            </Grid>
          </Grid>
          <SummaryInspectionContract project={project} />
          <CollapsibleContainer title={<FormattedMessage id="programs.inspection.details" />}>
            <MoreDetailInspectionContract project={project} />
          </CollapsibleContainer>
          <Divider />
        </>
      )}
    </Grid>
  );
};

InspectionComponent.propTypes = {
  currentUser: PropTypes.object,
  projectId: PropTypes.number
};

export const Inspection = connect(state => ({
  currentUser: getCurrentUser(state)
}))(InspectionComponent);
